import React from 'react';
import "../styles/PaymentPolicy.css"; // We'll create this CSS file

const PaymentPolicy = () => {
  return (
    <div className="payment-policy-container">
      <h1 className="payment-policy-title fsh2 m1">Payment Policy</h1>
      
      <p className="payment-policy-intro">
        Thank you for choosing to register for our competitions and online seminars. Please read our payment policy carefully before making any payment.
      </p>
      
      <div className="policy-section">
        <h2 className="section-title">1. Payment Gateway</h2>
        <p className="section-text">
          All payments for registrations are processed securely with trusted and secure payment gateway. We accept payments via:
        </p>
        <ul className="payment-methods-list">
          <li>Credit/Debit Cards</li>
          <li>UPI</li>
          <li>Net Banking</li>
          <li>Wallets</li>
        </ul>
      </div>
      
      <div className="policy-section">
        <h2 className="section-title">2. Registration Confirmation</h2>
        <p className="section-text">
          Once the payment is successfully completed:
        </p>
        <ul className="policy-list">
          <li>You will receive an email confirmation with the registration details.</li>
          <li>If you do not receive confirmation within 24 hours, please contact us with your transaction ID.</li>
        </ul>
      </div>
      
      <div className="policy-section">
        <h2 className="section-title">3. Refund and Cancellation Policy</h2>
        <ul className="policy-list">
          <li>All payments made are non-refundable, except in cases of event cancellation by the organizers.</li>
          <li>In case of duplicate payment, a refund will be processed within 7–10 working days after verification.</li>
          <li>Registration is non-transferable unless specified otherwise in the event guidelines.</li>
        </ul>
      </div>
      
      <div className="policy-section">
        <h2 className="section-title">4. Failed or Incomplete Transactions</h2>
        <p className="section-text">
          If your payment fails but the amount is deducted from your bank account:
        </p>
        <p className="contact-email">
          Please contact us at <a href="mailto:support@mpeoples.in">support@mpeoples.in</a> with transaction details.
        </p>
      </div>
      
      <div className="policy-section">
        <h2 className="section-title">5. Dispute Resolution</h2>
        <p className="section-text">
          In case of any payment-related disputes, please contact us directly at <a href="mailto:support@mpeoples.in">support@mpeoples.in</a>. We aim to resolve all queries within 3 business days.
        </p>
      </div>
      
      <div className="policy-section">
        <h2 className="section-title">6. Security</h2>
        <p className="section-text">
          Your payment and personal details are secure which uses industry-standard encryption and complies with PCI-DSS standards.
        </p>
      </div>
    </div>
  );
};

export default PaymentPolicy;